/**
 * Script embutido no HTML exportado para comentários Gepetto + Moodle AJAX.
 * Tokens [[GEPPETTO_CMID]] e [[GEPPETTO_SESSKEY]] são substituídos no plugin ao servir o arquivo.
 */
export const GEPPETTO_COMMENTS_EXPORT_SCRIPT = `
<style>
  .madri-geppetto-comments { font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; color: #1e293b; max-width: 800px; margin: 0 auto; padding: 20px; }
  .madri-gc-composer-card { background: #fff; border: 1px solid #e2e8f0; border-radius: 12px; padding: 16px; margin-bottom: 24px; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05); }
  .madri-gc-ta { border: 1px solid #e2e8f0; border-radius: 8px; padding: 12px; font-size: 14px; width: 100%; resize: vertical; min-height: 80px; transition: all 0.2s; font-family: inherit; margin-bottom: 12px; box-sizing: border-box; }
  .madri-gc-ta:focus { outline: none; border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1); }
  .madri-gc-btn-primary { background: #3b82f6; color: #fff; border: none; border-radius: 8px; padding: 8px 20px; font-weight: 600; cursor: pointer; transition: background 0.2s; font-size: 14px; }
  .madri-gc-btn-primary:hover { background: #2563eb; }
  .madri-gc-btn-subtle { background: none; border: none; color: #64748b; font-size: 13px; cursor: pointer; padding: 4px 8px; border-radius: 4px; transition: all 0.2s; }
  .madri-gc-btn-subtle:hover { background: #f1f5f9; color: #334155; }

  .madri-gc-item { background: #fff; border: 1px solid #f1f5f9; border-radius: 12px; padding: 16px; margin-bottom: 12px; position: relative; transition: all 0.2s; }
  .madri-gc-root { box-shadow: 0 2px 4px rgba(0,0,0,0.02); }
  .madri-gc-root:hover { border-color: #e2e8f0; box-shadow: 0 4px 12px -2px rgba(0,0,0,0.05); }

  .madri-gc-user-row { display: flex; align-items: center; gap: 12px; margin-bottom: 10px; }
  .madri-gc-avatar { width: 34px; height: 34px; border-radius: 50%; background: #3b82f6; color: #fff; display: flex; align-items: center; justify-content: center; font-weight: bold; font-size: 13px; flex-shrink: 0; text-transform: uppercase; object-fit: cover; border: 2px solid #fff; box-shadow: 0 0 0 1px #e2e8f0; }
  .madri-gc-fullname { font-weight: 600; color: #0f172a; font-size: 14px; }
  .madri-gc-date { color: #94a3b8; font-size: 12px; margin-left: auto; }

  .madri-gc-msg { font-size: 14px; line-height: 1.6; color: #334155; margin-left: 46px; white-space: pre-wrap; word-break: break-word; }

  .madri-gc-actions { margin-left: 46px; margin-top: 12px; display: flex; gap: 16px; align-items: center; }
  .madri-gc-action-link { color: #64748b; font-size: 13px; cursor: pointer; text-decoration: none; font-weight: 500; transition: color 0.1s; display: inline-flex; align-items: center; }
  .madri-gc-action-link:hover { color: #3b82f6; text-decoration: underline; }
  .madri-gc-action-link.liked { color: #3b82f6; font-weight: 700; }
  .madri-gc-action-link.danger:hover { color: #ef4444; }

  .madri-gc-thread-container { margin-left: 24px; border-left: 2px solid #f1f5f9; padding-left: 24px; margin-top: 12px; }
  .madri-gc-reply-toggle { color: #3b82f6; font-weight: 600; font-size: 13px; cursor: pointer; margin-left: 46px; margin-top: 12px; display: inline-flex; align-items: center; gap: 6px; user-select: none; }
  .madri-gc-reply-toggle:hover { text-decoration: underline; }

  .madri-gc-pagination { text-align: center; margin-top: 24px; }
  .madri-gc-btn-loadmore { background: #fff; color: #64748b; border: 1px solid #e2e8f0; border-radius: 20px; padding: 10px 24px; font-size: 13px; cursor: pointer; transition: all 0.2s; font-weight: 600; }
  .madri-gc-btn-loadmore:hover { border-color: #cbd5e1; color: #1e293b; background: #f8fafc; }
</style>
<script>
(function(){
'use strict';
function boot(){
  var nodes=document.querySelectorAll('.madri-geppetto-comments');
  for(var i=0;i<nodes.length;i++) initBlock(nodes[i]);
}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', boot);
else boot();

function initBlock(root){
  var cmid=String(root.getAttribute('data-cmid')||'');
  var sk=String(root.getAttribute('data-sesskey')||'');
  var ek=String(root.getAttribute('data-element-key')||'');
  var listEl=root.querySelector('.madri-gc-list');
  var compEl=root.querySelector('.madri-gc-composer');
  if(!listEl||!ek) return;
  if(!cmid||!sk||cmid.indexOf('[')!==-1||sk.indexOf('[')!==-1){
    listEl.innerHTML='<div style="background:#f8fafc;border-radius:12px;padding:24px;text-align:center;color:#64748b;font-size:14px;border:1px dashed #e2e8f0">Pré-visualização: comentários ativos no Moodle após publicar o arquivo.</div>';
    if(compEl) compEl.innerHTML='';
    return;
  }
  var cmidN=parseInt(cmid,10);
  var uid=0;
  // expandedItems armazena quais IDs de comentários estão expandidos (mostrando filhos)
  var expandedItems = {}; 
  var currentPage=0;
  var perPage=10;
  var loadedComments=[];

  function ajax(method,args){
    var u=location.origin+'/lib/ajax/service.php?sesskey='+encodeURIComponent(sk);
    return fetch(u,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify([{index:0,methodname:method,args:args}])})
      .then(function(r){return r.json();})
      .then(function(d){
        if(!d||!d[0]) throw new Error('net');
        if(d[0].error){
          var ex=d[0].exception||{};
          throw new Error(ex.message||d[0].errorcode||'err');
        }
        return d[0].data;
      });
  }
  function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }
  function fmt(ts){
    try{ var d=new Date(ts*1000); var now=new Date();
      if(now-d < 60000) return 'Agora';
      if(now-d < 3600000) return Math.floor((now-d)/60000)+' min atrás';
      return d.toLocaleString(undefined,{dateStyle:'short',timeStyle:'short'});
    }catch(e){ return ''; }
  }
  function getInitials(name){
    var p=String(name||'?').split(' ');
    if(p.length>1) return (p[0][0]+p[p.length-1][0]).toUpperCase();
    return p[0][0].toUpperCase();
  }

  function renderComposer(){
    if(!compEl || compEl.getAttribute('data-init')) return;
    if(!uid){ compEl.innerHTML=''; return; }
    compEl.innerHTML='<div class="madri-gc-composer-card">'+
      '<textarea class="madri-gc-ta" placeholder="O que você está pensando?"></textarea>'+
      '<div style="text-align:right"><button type="button" class="madri-gc-btn-primary madri-gc-sendroot">Enviar Comentário</button></div>'+
      '</div>';
    compEl.setAttribute('data-init','1');
    var btn=compEl.querySelector('.madri-gc-sendroot');
    var ta=compEl.querySelector('.madri-gc-ta');
    btn.onclick=function(){
      var txt=String(ta.value||'').trim();
      if(!txt) return;
      btn.disabled=true; btn.textContent='Enviando...';
      ajax('mod_gepettoresource_comments_add',{cmid:cmidN,element_key:ek,parentid:0,message:txt}).then(function(){
        ta.value=''; btn.disabled=false; btn.textContent='Enviar Comentário';
        currentPage=0; loadedComments=[]; refreshAll(); 
      }).catch(function(e){ alert('Erro: '+(e.message||'Falha ao enviar')); btn.disabled=false; btn.textContent='Enviar Comentário'; });
    };
  }

  function oneCommentHtml(c, isRoot){
    var hasReplies = c.replycount > 0;
    var isOpen = !!expandedItems[c.id];
    var avatarCol = (c.userid % 5);
    var colors = ['#3b82f6','#10b981','#f59e0b','#ef4444','#8b5cf6'];
    var avatarStyle = 'padding:0;background:'+colors[avatarCol];
    
    // Fallback de imagem robusto
    var avatarHtml = c.profileimageurl ? 
      '<img src="'+c.profileimageurl+'" class="madri-gc-avatar" style="padding:0" onerror="this.onerror=null;this.src=\\'data:image/svg+xml,%3Csvg xmlns=\\'http://www.w3.org/2000/svg\\' width=\\'34\\' height=\\'34\\' viewBox=\\'0 0 34 34\\'%3E%3Crect width=\\'100%25\\' height=\\'100%25\\' fill=\\'%23f1f5f9\\'/%3E%3Ctext x=\\'50%25\\' y=\\'55%25\\' dominant-baseline=\\'middle\\' text-anchor=\\'middle\\' font-family=\\'sans-serif\\' font-size=\\'12\\' fill=\\'%2394a3b8\\' font-weight=\\'bold\\'%3E'+getInitials(c.fullname)+'%3C/text%3E%3C/svg%3E\\'">':
      '<div class="madri-gc-avatar" style="'+avatarStyle+'">'+getInitials(c.fullname)+'</div>';

    var h = '<div class="madri-gc-item '+(isRoot?'madri-gc-root':'')+'" data-id="'+c.id+'">'+
      '<div class="madri-gc-user-row">'+
        avatarHtml +
        '<div class="madri-gc-fullname">'+esc(c.fullname)+'</div>'+
        '<div class="madri-gc-date">'+fmt(c.timecreated)+(c.edited?' <span style="font-style:italic;font-size:11px">(editado)</span>':'')+'</div>'+
      '</div>'+
      '<div class="madri-gc-msg">'+esc(c.message)+'</div>'+
      '<div class="madri-gc-actions">'+
        '<span class="madri-gc-action-link madri-gc-like '+(c.liked?'liked':'')+'" data-id="'+c.id+'">Curtir ('+(c.likescount||0)+')</span>'+
        '<span class="madri-gc-action-link madri-gc-reply" data-id="'+c.id+'">Responder</span>';
    if(c.canedit) h+='<span class="madri-gc-action-link madri-gc-edit" data-id="'+c.id+'">Editar</span>';
    if(c.candelete) h+='<span class="madri-gc-action-link madri-gc-del danger" data-id="'+c.id+'">Excluir</span>';
    h+='<span class="madri-gc-action-link madri-gc-report" data-id="'+c.id+'" style="margin-left:auto;color:#cbd5e1">Denunciar</span>';
    h+='</div>';

    if(hasReplies){
      var label = c.replycount === 1 ? '1 resposta' : c.replycount + ' respostas';
      var arrow = isOpen ? '▲' : '▼';
      h += '<div class="madri-gc-reply-toggle" data-rid="'+c.id+'">'+arrow+' '+label+'</div>';
    }

    if(isOpen){
      h += '<div class="madri-gc-thread-container"><div class="madri-gc-thread" data-parent="'+c.id+'"></div></div>';
    }
    h += '</div>';
    return h;
  }

  function bindEvents(scope){
    var likes=scope.querySelectorAll('.madri-gc-like');
    for(var i=0;i<likes.length;i++) likes[i].onclick=function(e){
      var el=this; var id=parseInt(el.getAttribute('data-id'),10);
      ajax('mod_gepettoresource_comments_like',{cmid:cmidN,element_key:ek,commentid:id}).then(function(d){
        el.textContent = d.liked ? 'Curtida ('+d.likescount+')' : 'Curtir ('+d.likescount+')';
        if(d.liked) el.classList.add('liked'); else el.classList.remove('liked');
      });
    };
    var replies=scope.querySelectorAll('.madri-gc-reply');
    for(var i=0;i<replies.length;i++) replies[i].onclick=function(e){
      var el=this; 
      var parentCommentId=parseInt(el.getAttribute('data-id'),10);
      if(el.getAttribute('data-active')) return;
      el.setAttribute('data-active','1');
      var box=document.createElement('div');
      box.style.cssText='margin:12px 0 0 46px;background:#f8fafc;padding:12px;border-radius:8px;border:1px solid #e2e8f0';
      box.innerHTML='<textarea class="madri-gc-ta" style="min-height:60px;margin-bottom:8px" placeholder="Sua resposta..."></textarea>'+
        '<div style="text-align:right;gap:8px;display:flex;justify-content:flex-end">'+
        '<button type="button" class="madri-gc-btn-subtle cancel">Cancelar</button>'+
        '<button type="button" class="madri-gc-btn-primary send" style="padding:6px 14px">Responder</button></div>';
      el.parentNode.parentNode.appendChild(box);
      var ta=box.querySelector('textarea'); ta.focus();
      box.querySelector('.cancel').onclick=function(){ box.remove(); el.removeAttribute('data-active'); };
      box.querySelector('.send').onclick=function(){
        var txt=String(ta.value||'').trim(); if(!txt) return;
        this.disabled=true;
        ajax('mod_gepettoresource_comments_add',{cmid:cmidN,element_key:ek,parentid:parentCommentId,message:txt}).then(function(){
          expandedItems[parentCommentId] = true;
          currentPage=0; loadedComments=[]; refreshAll();
        }).catch(function(e){ alert(e.message); });
      };
    };
    var edits=scope.querySelectorAll('.madri-gc-edit');
    for(var i=0;i<edits.length;i++) edits[i].onclick=function(){
      var id=parseInt(this.getAttribute('data-id'),10);
      var row = this.parentNode.parentNode;
      var msgEl = row.querySelector('.madri-gc-msg');
      var old = msgEl.textContent;
      var nv=prompt('Editar comentário:', old);
      if(nv && nv.trim() && nv.trim()!==old.trim()){
        ajax('mod_gepettoresource_comments_edit',{cmid:cmidN,element_key:ek,commentid:id,message:nv.trim()}).then(function(){
          msgEl.textContent = nv.trim();
        });
      }
    };
    var dels=scope.querySelectorAll('.madri-gc-del');
    for(var i=0;i<dels.length;i++) dels[i].onclick=function(){
      if(!confirm('Excluir este comentário?')) return;
      var id=parseInt(this.getAttribute('data-id'),10);
      ajax('mod_gepettoresource_comments_delete',{cmid:cmidN,element_key:ek,commentid:id}).then(function(){
        currentPage=0; loadedComments=[]; refreshAll();
      });
    };
    var toggles=scope.querySelectorAll('.madri-gc-reply-toggle');
    for(var i=0;i<toggles.length;i++) toggles[i].onclick=function(){
      var rid=parseInt(this.getAttribute('data-rid'),10);
      if(expandedItems[rid]) delete expandedItems[rid];
      else {
        // Para manter apenas uma família aberta no mesmo nível, poderiamos limpar, 
        // mas o Moodle suporta múltiplos. Vamos respeitar a regra de "fechar anterior" se for raiz.
        var isRootToggle = !!this.closest('.madri-gc-root');
        if(isRootToggle) {
          // Se clicou em uma nova raiz, opcionalmente fecha as outras (YouTube-like)
          // expandedItems = {}; // Descomente para fechar tudo ao abrir uma nova raiz
          // expandedItems[rid] = true;
        }
        expandedItems[rid] = true;
      }
      refreshAll();
    };
    var reports=scope.querySelectorAll('.madri-gc-report');
    for(var i=0;i<reports.length;i++) reports[i].onclick=function(){
      var note=prompt('Motivo da denúncia (opcional):');
      if(note===null) return;
      var id=parseInt(this.getAttribute('data-id'),10);
      ajax('mod_gepettoresource_comments_report',{cmid:cmidN,element_key:ek,commentid:id,note:note}).then(function(){
        alert('Obrigado. O comentário foi enviado para análise dos professores.');
      });
    };
  }

  function loadMore(){
    currentPage++;
    refreshAll(true);
  }

  function fillThread(parentId){
    var holder=listEl.querySelector('.madri-gc-thread[data-parent="'+parentId+'"]');
    if(!holder) return;
    holder.innerHTML='<div style="color:#94a3b8;font-size:13px;padding:8px 0">Carregando respostas...</div>';
    ajax('mod_gepettoresource_comments_list',{cmid:cmidN,element_key:ek,parentid:parentId,page:0,perpage:50})
      .then(function(d){
        var arr=d.comments||[];
        if(!arr.length){ holder.innerHTML='<div style="color:#94a3b8;font-size:13px;padding:8px 0">Sem respostas.</div>'; return; }
        holder.innerHTML=arr.map(function(c){ return oneCommentHtml(c, false); }).join('');
        bindEvents(holder);
        // Recursivamente preenche filhos se estiverem expandidos
        for(var i=0; i<arr.length; i++) {
          if(expandedItems[arr[i].id]) fillThread(arr[i].id);
        }
      });
  }

  function refreshAll(isLoadMore){
    ajax('mod_gepettoresource_comments_list',{cmid:cmidN,element_key:ek,parentid:0,page:currentPage,perpage:perPage})
      .then(function(d){
        uid=d.currentuserid||0;
        var arr=d.comments||[];
        renderComposer();
        
        if(!isLoadMore) loadedComments = [];
        var existingIds = loadedComments.map(function(lc){ return lc.id; });
        for(var i=0; i<arr.length; i++){
          if(existingIds.indexOf(arr[i].id) === -1) loadedComments.push(arr[i]);
        }

        if(!loadedComments.length){
          listEl.innerHTML='<div style="text-align:center;padding:40px;color:#94a3b8;font-size:15px">Ainda não há comentários. Seja o primeiro!</div>';
        } else {
          listEl.innerHTML=loadedComments.map(function(c){ return oneCommentHtml(c, true); }).join('');
          
          if(d.total > loadedComments.length){
            var pgWrap = document.createElement('div');
            pgWrap.className = 'madri-gc-pagination';
            var btn = document.createElement('button');
            btn.className = 'madri-gc-btn-loadmore';
            btn.textContent = 'Ver mais comentários ('+(d.total - loadedComments.length)+' restantes)';
            btn.onclick = loadMore;
            pgWrap.appendChild(btn);
            listEl.appendChild(pgWrap);
          }
        }
        bindEvents(listEl);
        // Preenche recursivamente todos os itens expandidos
        Object.keys(expandedItems).forEach(function(id){
          fillThread(parseInt(id,10));
        });
      })
      .catch(function(e){ listEl.innerHTML='<div style="color:#ef4444;text-align:center;padding:20px">'+esc(e.message||'Erro ao carregar')+'</div>'; });
  }

  refreshAll();
}
})();
</script>
`;
